<template>
  <p-scroll-y-transition hide-on-leave>
    <p-container v-if="mounted">
      <p-row>
        <p-col xs12 sm7 md8>
          <p-row column fill-height>
            <p-col shrink>
              <h3 class="mb-5">
                {{ $t("core.page.registration.page.title") }}
              </h3>
            </p-col>
            <p-col grow>
              <p-form :model="user" no-summary>
                <slot name="prepend-input-fields"></slot>
                <p-text-field
                  v-model="user.email"
                  autofocus
                  :label="$t('core.page.registration.label.userEmail')"
                  @keyup.enter="tabToNextInput()"
                ></p-text-field>
                <p-text-field
                  v-model="user.userName"
                  :label="$t('core.page.registration.label.userName')"
                  @keyup.enter="tabToNextInput()"
                ></p-text-field>
                <p-text-field
                  v-model="user.password"
                  type="password"
                  :label="$t('core.page.registration.label.userPassword')"
                  @keyup.enter="tabToNextInput()"
                ></p-text-field>
                <p-text-field
                  v-model="user.passwordRepeat"
                  type="password"
                  :label="$t('core.page.registration.label.userPasswordRepeat')"
                  @keyup.enter="doRegister()"
                ></p-text-field>
                <slot name="append-input-fields"></slot>
              </p-form>
            </p-col>
            <p-col shrink>
              <p-button
                stretch
                class="mt-5"
                :loading="isLoading"
                :disabled="isLoading"
                @click="doRegister()"
              >
                {{ $t("core.page.registration.button.registerAction") }}
              </p-button>
            </p-col>
            <p-col v-if="_.component.hasSlot(this, 'append-form')" shrink>
              <slot name="append-form"></slot>
            </p-col>
          </p-row>
        </p-col>
        <p-col xs12 sm1 justify-center>
          <p-divider vertical class="hidden-xs-only"></p-divider>
          <p-divider class="hidden-sm-and-up"></p-divider>
        </p-col>
        <p-col xs12 sm4 md3>
          <p-row column fill-height>
            <p-col grow>
              <h3>
                {{ $t("core.page.registration.label.alreadyHaveAccount") }}
              </h3>
            </p-col>
            <p-col shrink>
              <p-button stretch secondary @click="gotoLogin">
                {{ $t("core.page.registration.button.gotoLogin") }}
              </p-button>
            </p-col>
          </p-row>
        </p-col>
      </p-row>
      <p-row class="mt-1">
        <p-col xs12>
          <p-request-alert v-model="requestError"></p-request-alert>
        </p-col>
      </p-row>
    </p-container>
  </p-scroll-y-transition>
</template>

<script lang="ts">
  import Vue from 'vue';
  import UserRegisterRequestViewModel from '../../../services/v1/viewModel/resource/UserRegisterRequestViewModel';

  export default Vue.extend({
    auth: false,
    layout: ['layout-exterior', '_exterior'],
    data: () => ({
      mounted: false,
      user: new UserRegisterRequestViewModel(),
      isLoading: false,
      requestError: undefined,
    }),
    mounted() {
      this.mounted = true;
      this.loadQRData();
    },
    methods:
      {
        tabToNextInput() {
          const inputs = document.getElementsByTagName('input');
          for (let i = 0; i < inputs.length; i += 1) {
            const input = inputs[i];
            if (document!.activeElement!.id === input.id && i + 1 < inputs.length) {
              const nextInput = inputs[i + 1] as HTMLInputElement;
              nextInput.focus();
              break;
            }
          }
        },
        loadQRData() {
          const query = this.$router.currentRoute?.query ?? {};
          const { username, email, registrationKey } = query as Record<string, string>;
          this.user.userName = username;
          this.user.email = email;
          this.user.registrationKey = registrationKey;
        },
        gotoLogin() {
          Vue.$router.push({ path: '/_exterior/login', query: this.$route.query });
        },
        gotoVerifyUser() {
          Vue.$router.push({ path: '/_exterior/verify-user', query: this.$route.query });
        },
        doRegister() {
          if (!this.user.validate()) {
            return;
          }
          this.isLoading = true;
          this.$service.api.core.users.register(this.user)
            .then(() => {
              this.isLoading = false;
              this.gotoVerifyUser();
            })
            .catch((error: any) => {
              this.isLoading = false;
              this.requestError = error;
            });
        },
      },
  });

</script>
